import CartCheckoutButton from '@/components/sections/builder/elements/body/cart-total/checkout-button';
import ElementContent from '@/components/sections/builder/elements/body/cart-total/content';
import ElementSetting from '@/components/sections/builder/elements/body/cart-total/setting';
import CartSubtotalPrice from '@/components/sections/builder/elements/body/cart-total/subtotal-price';
import { ElementDataType } from '@/components/sections/builder/elements/body/cart-total/type';
import { BetweenHorizonalStart } from 'lucide-react';

const defaultData: ElementDataType = {
  name: 'Cart Subtotal',
};

export const ElementPreviewIcon = BetweenHorizonalStart;

const CartTotal = {
  type: 'cart_total',
  group: 'body_cart',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [CartSubtotalPrice, CartCheckoutButton],
  childs: [CartSubtotalPrice, CartCheckoutButton],
  maxEntries: 1,
  isImmutable: true,
};

export default CartTotal;
